{
  "title": "How to decline to judge or withdraw from judging a competition",
  "description": "If you cannot serve, decline at the invitation stage, or withdraw once you have assignments, so the organizer can rearrange early.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "After this, the organizer knows you cannot serve and can invite you again or reassign the work, and you will no longer be reminded.",
  "roleNote": "Judge",
  "prerequisites": ["You were invited to judge, or you are already a judge of that competition"],
  "pathLabel": "Overview → Invitations waiting for your answer; Judging assignments → Can't serve as a judge? Withdraw from this competition",
  "steps": [
    {
      "title": "1. Not accepted yet: decline",
      "description": "With an existing platform account, sign in and press \"Decline\" under \"Judge invitations waiting for your answer\" on your Overview page, optionally give a reason, then press \"Confirm decline\". Declining grants no role; the organizer sees \"Declined\" with your reason in the invitation list and can invite you again. An invitation can be answered for 7 days."
    },
    {
      "title": "2. New account (temporary password)",
      "description": "A new account created with a temporary password becomes a judge automatically when it completes its first password change, so it cannot decline beforehand. If you cannot serve, press \"Can't serve as a judge? Withdraw from this competition\" on your assignments page and tick \"Also give up my judge role in this competition\" (it works even with no assignments), or contact the organizer directly."
    },
    {
      "title": "3. Already assigned: withdraw from this competition",
      "description": "Click \"Can't serve as a judge? Withdraw from this competition\" below your assignment list, give a reason (required) and confirm. The system cancels all of your assignments in that competition that have no submitted score; your submitted scores, your judge role and your draft records are not deleted. If you also tick \"Also give up my judge role in this competition\", your judge role is removed too, the competition no longer appears in your judging assignments, and the organizer must invite you again for you to serve."
    },
    {
      "title": "4. What happens next",
      "description": "The organizer sees your reason in the audit trail and sees your assigned count drop in Review Progress, then reassigns the work to other judges. You cannot undo it yourself; ask the organizer if you need to be restored."
    }
  ],
  "afterward": [
    "A declined invitation shows as \"Declined\" with the reason in the organizer's invitation list",
    "After withdrawing, your unsubmitted assignments are cancelled and submitted scores are untouched",
    "Both declining and withdrawing leave an audit record"
  ],
  "nextSteps": "If you only want to check which submissions you have, see \"How to view the submissions assigned to me\".",
  "faq": [
    {
      "q": "Can I change my mind after declining?",
      "a": "Not yourself. Contact the organizer, who can invite you again."
    },
    {
      "q": "Are the scores I already submitted deleted when I withdraw?",
      "a": "No. Submitted scores, your judge role and your draft records are kept; only assignments without a submitted score are cancelled."
    },
    {
      "q": "I only cannot judge one or two submissions. Must I withdraw entirely?",
      "a": "No. If it is because of a relationship with the participants, use \"Declare conflict of interest\" next to that submission instead; withdrawing cancels all your unsubmitted assignments in the competition."
    }
  ]
}
